import Transform from '@ember-data/serializer/transform';
import OrderMoney from '../../models/subscriptions/order-money';
export default Transform.extend(OrderMoney);